// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"a9-z"};